import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import { ContentItem66 as ContentItem } from '#client/components/Grid';

import CardsSetting from './CardsSetting';
import VirtualCardInfo from './VirtualCardInfo';

export default function Content({ handleClose }) {
  return (
    <ContentItem>
      <Stack
        gap={{ xs: '32px', md: '40px' }}
        mb={{ xs: '120px' }}
      >
        <VirtualCardInfo />
        <CardsSetting handleClose={handleClose} />
      </Stack>
    </ContentItem>
  );
}

Content.propTypes = {
  handleClose: PropTypes.func.isRequired
};
